import { MenuItem, Select, type SelectChangeEvent } from '@mui/material';
import { useI18n } from './I18nProvider';
import { LOCALE_NAMES, SUPPORTED_LOCALES, type Locale } from './locales';

export default function LocaleSwitcher({ size = 'small' }: { size?: 'small' | 'medium' }) {
  const { locale, setLocale } = useI18n();
  const handleChange = (e: SelectChangeEvent) => setLocale(e.target.value as Locale);

  return (
    <Select value={locale} onChange={handleChange} size={size} variant="outlined" sx={{ minWidth: 120 }}>
      {SUPPORTED_LOCALES.map((l) => (
        <MenuItem key={l} value={l}>
          {LOCALE_NAMES[l]}
        </MenuItem>
      ))}
    </Select>
  );
}
